// @flow
import React, { useState, useEffect } from 'react';
import { getTheme, addThemeListener, removeThemeListener } from '../../utils/darkmode';
import styles from './SubscribeForm.module.scss';

type Props = {|
    large?: boolean,
|};

const SubscribeForm = ({ large }: Props) => {
    const [theme, setTheme] = useState<string | null>(null);
    const [isReady, setIsReady] = useState(false);
    const height = large ? "320" : "120";

    useEffect(() => {
        const currentTheme = getTheme();
        if (currentTheme) {
            setTheme(currentTheme);
            setIsReady(true);
        }

        const listener = () => {
            const newTheme = getTheme();
            if (newTheme) {
                setTheme(newTheme);
                setIsReady(true);
            }
        };
        addThemeListener(listener);
        return () => {
            removeThemeListener(listener);
        };
    }, []);

    const isLightMode = theme === 'light';

    return (
        <div className={`${styles['container']} ${isLightMode ? styles['light'] : ''} ${isReady ? styles['ready'] : ''}`}>
            <iframe
                src="https://cathodereytube.substack.com/embed"
                height={height}
                style={{ display: 'block', backgroundColor: 'transparent' }}
                frameBorder="0"
                scrolling="no"
            />
        </div>
    );
};

export default SubscribeForm;